// Sticky header — #header je sticky přes CSS; tady jen přepínáme .is-scrolled
// pro stín a kompakci. Práh dle 02-komponenty.md §20: kompakt až ve chvíli, kdy
// sticky blok doopravdy dosedne na horní hranu (nad ním žije topbar proměnné
// výšky, pevný počet pixelů by to netrefil).
//
// POZOR na zpětnou vazbu přes scroll anchoring (ověřeno 2026-07-31): kompakce
// hlavičku zkrátí — na desktopu o 24 px — takže se zkrátí i dokument a
// prohlížeč SÁM sníží scrollY o tutéž hodnotu, aby obsah zůstal opticky na
// místě. Hlavička se tím odlepí od horní hrany, podmínka se obrátí, třída
// zmizí, hlavička se zvětší, scrollY se vrátí… a takhle pořád dokola. Jeden
// krok kolečka na hranici prahu spustil 40+ přepnutí za 2,5 s.
//
// Řešení je hystereze: zapínáme na dosednutí (top <= 0), ale vypínáme až když
// je hlavička OFF_GAP pod hranou. Rezerva musí být větší než největší kompakce,
// jinak si ji skok od anchoringu překročí sám a smyčka se vrátí.
//
// Kompenzace výšky (2026-08-24): anchoring je v CSS vypnutý (`overflow-anchor:
// none`), takže bez další péče obsah pod hlavičkou při kompakci SKOČÍ nahoru
// o oříznutých 24 px — a s animovanou výškou (.28s) to byl reflow celé stránky
// každý frame, na homepage s videem a na detailu viditelně trhaný. Přechod je
// teď okamžitý (token --bs-t-header = 0 s) a rozdíl výšky se vrací dokumentu
// jako `margin-bottom` sticky bloku: přirozená pozice hlavičky se nemění,
// všechno pod ní zůstane přesně tam, kde bylo, a hlavička drží top 0. Proč
// spodní a ne horní margin: v pásmu odlepení (0–OFF_GAP px) by horní margin
// otevřel mezeru mezi topbarem/promo pruhem a hlavičkou; spodní margin je
// bílá na bílé pod hlavičkou. Při odlepení se margin vrací na nulu a hlavička
// doroste do něj — obsah se opět nehne.
const OFF_GAP = 80;

export function initStickyHeader() {
  const header = document.getElementById('header');
  if (!header || header.dataset.bsSticky) return;
  header.dataset.bsSticky = '1';

  let ticking = false;
  let scrolled = false;

  // Přepnutí třídy s kompenzací: změř výšku před/po a rozdíl dej do marginu.
  // Měří se skutečná výška (offsetHeight), ne konstanta — mobil má jinou
  // kompakci než desktop a admin bar / promo pruh výšku hlavičky nemění.
  function setScrolled(on) {
    scrolled = on;
    const before = header.offsetHeight;
    header.classList.toggle('is-scrolled', on);
    if (on) {
      const delta = before - header.offsetHeight;
      header.style.marginBottom = delta > 0 ? delta + 'px' : '';
    } else {
      header.style.marginBottom = '';
    }
  }

  function update() {
    ticking = false;
    const top = header.getBoundingClientRect().top;
    if (!scrolled && top <= 0.5) {
      setScrolled(true);
    } else if (scrolled && (top > OFF_GAP || window.scrollY <= 0.5)) {
      // druhá větev: úplný vrchol stránky = hlavička na přirozené pozici, i když
      // ta leží pod OFF_GAP (mobil: nad hlavičkou je jen promo pruh ~38–107 px,
      // po jeho zavření 0 px — bez téhle větve by stín zůstal svítit i nahoře)
      setScrolled(false);
    }
  }

  function schedule() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  // První měření až v rAF: synchronní `getBoundingClientRect` uprostřed bootu vynutil
  // layout stránky ještě ve stavu kostry (26–84 ms při CPU 4×, profil 2026-10-13,
  // ops/sweeps/2026-10-13-lcp-kostra/boot-profile.mjs). rAF běží za koncem bootu
  // a před prvním vykreslením odkryté stránky, takže stav třídy sedí od prvního snímku.
  schedule();
}
